import { PropTypes } from 'prop-types'
const Course = ({ name, img }) => {
  return (
    <div className='course h-[30rem]  relative overflow-hidden  group  bg-gray-400 flex rounded-3xl cursor-pointer hover:scale-105 transition-all duration-500'>
      <img
        src={img}
        height={500}
        width={290}
        className='w-full h-[40rem]  object-cover   group-hover:scale-[1.2] transition-all !duration-500'
        alt={'image-' + name}
      />
      <div className='absolute inset-0 bg-[rgba(0,0,0,0.2)]'></div>
      <div className='absolute  left-0 top-0 bg-gradient-to-b from-black via-transparent to-transparent'></div>
      <div className='absolute bottom-0 p-4 flex flex-col justify-start items-start '>
        <div className=' text-white text-[30px] lg:text-[30px] group-hover:lg:text-[35px] 2xl:text-[40px] font-bold group-hover:2xl:text-[45px] transition-all !duration-500 '>
          {name}
        </div>
      </div>
    </div>
  )
}
Course.propTypes = {
  name: PropTypes.string,
  img: PropTypes.string
}
export default Course
